import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AsyncImage } from "loadable-image";
import { Translation } from "react-i18next";
import Emitter from "_actions/emitter";

const NonameHeroBox = (props) => {
  const containerRef = useRef(null);
  const [H, setH] = useState(null);
  const { item, index, provider } = props;

  const resizeBox = () => {
    if (containerRef && containerRef.current) {
      const w = containerRef.current?.clientWidth;
      const prgmaticName = document.querySelector(".prgmaticName")?.offsetHeight;
      containerRef.current.style.height = `${w + prgmaticName}px`;
      setH(`${w + prgmaticName}px`);
    }
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", resizeBox);
    window.addEventListener("resize", resizeBox);
  }, []);

  return (
    <Translation>
      {(t) => (
        <>
          <div
            ref={containerRef}
            key={item.id_game + item.display_name + item.vendor}
            className="GameBox h-[143px] md:h-[220px]  bg-primary-500 md:bg-secondary-500 group/item cursor-pointer md:border md:border-primary-500"
            onLoad={() => resizeBox()}
            style={{
              height: H ? H : undefined,
            }}
          >
            <div className="games-img">
              <AsyncImage
                className="h-full w-full rounded-t-[2.5vw] md:rounded-t-md"
                src={item.image}
                alt={item.display_name}
                loader={
                  <div className="skeleton w-full h-full bg-secondary-500">
                    <img src={require("../../../assets/img/gamebox1.png")} alt=""></img>
                  </div>
                }
                error={
                  <div className="bg-light-500 max-h-[136px] md:max-h-[220px] flex justify-center items-center">
                    <img
                      className="max-h-[136px] md:max-h-[220px]"
                      src={require("../../../assets/img/gamebox2.png")}
                      alt=""
                    ></img>
                  </div>
                }
              />
            </div>
            <div className="game-hover group-hover/item:before:opacity-80"></div>
            <div className="game-btns flex-col h-full">
              <div className="game-btn-item game-btn-title flex flex-row justify-start md:justify-center items-center text-center text-[#fff] text-sm px-2 py-0">
                {item.display_name}
              </div>
              <div className="game-btn-item game-btn-provider flex flex-row justify-start md:justify-center items-center text-[#b2b2b2] text-xs px-2 pb-1">
                {String(item.vendor).replaceAll("NONAMEHERO", " ").replaceAll("_", " ")}
              </div>
              {props.loggedIn ? (
                <Link
                  to={`/nonamehero/${item.vendor}/${item.id_game}`}
                  className="game-btn-item game-btn-play flex flex-row m-1 justify-start md:justify-center items-center text-xs border border-white rounded-md px-6 mt-2 py-1"
                >
                  {t("BUTTON_PLAY")}
                </Link>
              ) : (
                <div
                  className="game-btn-item game-btn-play flex flex-row m-1 justify-start md:justify-center items-center text-xs border border-white rounded-md px-6 mt-2 py-1"
                  onClick={() => {
                    Emitter.emit("LOGIN_MODAL", true);
                  }}
                >
                  {t("BUTTON_PLAY")}
                </div>
              )}
               
            </div>
          </div>
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state) => {
  const { authentication } = state;
  const { loggedIn } = authentication;
  return { loggedIn };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NonameHeroBox);
